package com.milta.feature.route.presentation

sealed interface WebImportRouteNavEvent {
    /** `POST /route-batches` then `POST /route-batches/{id}/dispatch` both succeeded (MIL-51) — the
     * caller (webApp's `Main.kt`) navigates back to "Tournées du jour". No payload: the screen
     * reads [WebImportRouteState.batchResult]/`drivers` — still in state at the moment this event
     * fires, since [WebImportRouteViewModel] never clears them on a successful dispatch — to build
     * its own confirmation message before this event is collected. */
    data object Dispatched : WebImportRouteNavEvent
}
